import {MarketoField} from './marketo-field.mobx-model';

export class MarketoSelectField extends MarketoField {
    constructor(
        label: string,
        mktoName: string,
        public options: Array<number | string>,
    ) {
        super(label, mktoName, {}, false);
    }
}
